<nav class="navbar toggle-color navbar-expand-lg navbar-dark fixed-top z-index-999">
    <!-- <mat-sidenav-container class="sidenav-parent" fixedInViewport="true">
        <mat-sidenav #sidenav mode="push" class="fs-16 text-center">
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="text-right app-website-header">
                        <button mat-icon-button class="close_button fs-16" (click)="sidenav.close()"
                            aria-label="Example icon button with a heart icon">
                            Close <mat-icon>close</mat-icon>
                        </button>
                    </div>
                    <div class="row">
                        <div class="col-md-12 text-left mt-70">
                            <div class="SN-Links1 pointer">
                                <span *ngIf="!loggedIn">
                                    <span *ngFor="let menu of menuNames">
                                        <a (click)="goToRespectiveScreen(menu,'sidenav')" *ngIf="menu == 'home'"
                                            [ngClass]="{'active':router.url !='/creators' && router.url !='/view' && router.url !='/organizers' && router.url !='/fans' && router.url !='/browse' && router.url !='/contactus' && router.url !='/privacypolicy' && router.url !='/termsandconditions' && router.url !='/signup' && !router.url.includes('view')}">Home</a>
                                        <a *ngIf="menu != 'home'"
                                            [ngClass]="{'active':router.url.includes(menu),'c-p':router.url.includes('view') && menu == 'browse'}"
                                            (click)="goToRespectiveScreen(menu,'sidenav')">{{menu}}</a>
                                    </span>
                                </span>
                                <a (click)="goToRespectiveScreen('userhome','sidenav')" *ngIf="loggedIn"
                                    [ngClass]="{'active':router.url.includes('userhome')}">Home</a>
                            </div>
                            <div class="SN-Links2 pointer">
                                <a *ngIf="loggedIn"
                                    [ngClass]="{'active':router.url.includes('user-dashboard/profile-settings/basic-info')}"
                                    (click)="redirectTo('user-dashboard/profile-settings/basic-info')">My Account</a> -->
    <!-- <a href="">Pricing</a> -->
    <!-- <a href="">About Us</a> -->
    <!-- <a (click)="redirectTo('contactus')"
                                    [ngClass]="{'active':router.url.includes('contactus')}">Contact Us</a>
                                    <a (click)="redirectTo('aboutus')"
                                    [ngClass]="{'active':router.url.includes('aboutus')}">About</a> -->
    <!-- <a href="">Turn on Dark Mode<span class="ml-2">
                                        <mat-slide-toggle></mat-slide-toggle>
                                    </span> </a> -->
    <!-- </div>
                            <div class="SN-Links2 pointer" *ngIf="!loggedIn"> -->
    <!-- <a href="">Search</a> -->
    <!-- <a (click)="redirectTo('signin')">Sign In</a>
                                <a [ngClass]="{'active':router.url.includes('signup')}"
                                    (click)="redirectTo('signup')">Sign Up</a> -->
    <!-- <a (click)="openKoopid()" [ngClass]="{'active':openChat}">Help</a> -->
    <!-- <div *ngIf="openChat" id="kpd_koopidtag" data-kpdprovemail="arun@arevea.tv"
                                    data-kpdembedded="true" data-kpdguest="true" data-kpdtag="Arevea Concierge"
                                    data-kpdproactive="" data-kpdproactivetimer="" data-kpdparams=""
                                    class="kpd_koopidtag pointer chat-styles"></div>
                            </div>
                            <div class="SN-footer">
                                <div class="row align-items-center">
                                    <div class="col-md-3">
                                        <div class="SN-logo"><img src="assets/logo.svg"></div>
                                        <div class="SN-text1 pt-10 pb-5">CONNECT WITH US</div>
                                        <div class="SN-social pointer">
                                            <a href="https://www.facebook.com/Areveatv-111754950520279/"
                                                target="_blank"><img src="assets/website/homepage/facebook.svg"></a> -->
    <!-- <a href="https://www.instagram.com/areveatv/" target="_blank"><img
                                                    src="assets/website/homepage/instagram.svg"></a> -->
    <!-- <a href=""><img src="assets/website/homepage/youtube.svg"></a> -->
    <!-- <a href="https://twitter.com/areveatv" target="_blank"><img
                                                    src="assets/website/homepage/twitter.svg"></a> -->
    <!-- </div>
                                    </div>
                                    <div class="col-md-9">
                                        <div><a href="https://play.google.com/store/apps/details?id=com.arevea.tv"
                                                target="_blank"><img src="assets/website/homepage/googleplay.png"
                                                    class="store-img"></a></div>
                                        <div><a href="https://apps.apple.com/in/app/arevea/id1535047464"
                                                target="_blank"><img src="assets/website/homepage/appstore.png"
                                                    class="store-img"></a></div>

                                    </div>
                                </div>
                                <div class="SN-Links3">
                                    Copyright 2020 Arevea Inc
                                    <a class="pointer" (click)="redirectTo('privacypolicy')">Privacy Policy</a>
                                    <a class="pointer" (click)="redirectTo('termsandconditions')">Terms of Service</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </mat-sidenav>

    </mat-sidenav-container>   this.imagedata-->
    <div class="logo pointer d-inline-block" *ngIf="deviceType == 'browser'"
        [ngClass]="{'logo-bg':router.url.includes('/userhome')}" (click)="goToMainScreen()"><img
            [src]="clientDetails.header_logo">
    </div>
    <div class="logo pointer d-inline-block" *ngIf="deviceType != 'browser'" (click)="gotoChannel()"
        [ngClass]="{'logo-bg':router.url.includes('/userhome')}"><img src="{{imagedata}}">
    </div>
    <div class="w-140p">
        <div class="pt-0  d-inline-block d-md-none d-sm-none " fxShow.xs="true">
            <app-google-translate></app-google-translate>
        </div>
    </div>
    <div class="dropdown app-currency mr-2 d-md-none d-sm-none" fxShow.xs="true"
        *ngIf="router.url.includes('/subscription-list')">
        <span class="btn btn-primary btn-primary-mobile-resp dropdown-toggle gt-toggle" (click)="clearSearch()"
            id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <span class="d-inline-block w-150p notranslate">
                <span *ngIf="currency?.length <= 4" class="active-color v-bottom">{{ currency }}</span>
                <span *ngIf="currency?.length > 4" class="active-color v-bottom">
                    {{ currency | slice: 0:4 }}
                    {{currency?.length > 4 ? "" : ""}}
                </span></span>
        </span>
        <div class="dropdown-menu p-0" aria-labelledby="dropdownMenuButton2">
            <input type="text" placeholder="Search.." class="search-input" [(ngModel)]="searchCurrency">
            <i class="fa fa-search drpdwn-search text-white " [ngClass]="{'user-search':userInfo?.id}"
                aria-hidden="true"></i>
            <span *ngFor="let currency of currencyJSON | filter: searchCurrency:'currency';let i=index"
                class="notranslate">
                <a class="dropdown-item fs-13"
                    (click)="changeCurrency(currency.currency)">{{currency.currency}}</a></span>
        </div>
    </div>
    <div *ngIf="!loggedIn && !userIdParam" fxShow.xs="true" fxHide class="fa fa-user" (click)="redirectTo('signin')">
    </div>
    <h2 class="expo-name" *ngIf="router.url.includes('expo/expo-details')">
        <a role="button" class="back-button" (click)="goBack()"><i class="fa fa-chevron-circle-left pr-10"
                aria-hidden="true"></i></a>
        {{expoInfo?.name}}
    </h2>


    <div class="w-140p ">
        <!-- <div class="pt-0  d-inline-block d-md-none d-sm-none " fxShow.xs="true">
            <app-google-translate></app-google-translate>
        </div> -->
        <div class="fs-16 pointer mr-10 mobile-active hoverchange"
            (click)="trackMyListClick()"
            *ngIf="userInfo?.id && loggedIn && router.url.includes('userhome')|| router.url.includes('mylist')"
            [ngClass]="{'element-active':router.url.includes('mylist') }" routerLink='/mylist'>My List
        </div>
        <ng-container *ngIf="!route?.snapshot?.queryParams?.user_id">
            <button fxShow.xs="true" fxHide id="arevea_mobile_nav" class="profile-pic notranslate p-0"
                (click)="rightsidenav.toggle();"
                *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')">
                {{displayName
                |uppercase}}
            </button>
            <div fxShow.xs="true" fxHide id="sideNav_mobile" class="artist-pic m-0 text-center pointer"
                (click)="rightsidenav.toggle();"
                *ngIf="!userInfo?.is_guest && loggedIn && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>
        </ng-container>
    </div>
    <div class="navbar-collapse align-content" id="navbarSupportedContent">
        <!-- <ul class="navbar-nav mr-auto" fxShow fxHide.xs="true" *ngIf="!loggedIn">
            <li class="nav-item" *ngFor="let menu of menuNames"
                [ngClass]="{'active':router.url.includes(menu),'active1':router.url.includes('view') && menu =='browse'}">
                <a class="nav-link" *ngIf="menu !='home'" (click)="goToRespectiveScreen(menu,'')">{{menu}} -->
        <!-- <span
                        class="sr-only">(current)</span> -->
        <!-- </a>
            </li>
        </ul> -->
        <!-- <buton  (click)="goToCart()">hgtf</buton> -->
        <!-- <div class="w-98"
            *ngIf="showCartIcon && !router.url.includes('network-market/product-cart') && !router.url.includes('/network-market/product-shipping')">
            <span (click)="cartProdCount > 0 ? goToCart() : false" class="cart-icon">
                <i class="fa fa-shopping-cart" style="font-size:24px">
                </i><span class="badge badge-light"> {{cartProdCount}} </span>
            </span>
        </div>  -->
        <div *ngIf="copyLinkPopup && cartProdCount > 0" class="position-ab-da p-2">

            <div class="closeText " (click)="closePopup()"> <span class="pointer secondary-bg-font-color1">Close</span>
            </div>
            <div class="borderBox">
                <div class="row sborderBottom p-2 no-gutters" *ngFor="let product of cartProducts">
                    <div class="col-lg-4">
                        <div class="imagediv"
                            [ngStyle]="{'background-image':' url( ' + product.product_data.media_url[0] + ' )'}">
                        </div>
                    </div>
                    <div class="col-8 pl-3">
                        <div class="row no-gutters">
                            <div class="col-10 secondary-bg-font-color1">
                                <span *ngIf="product?.product_data.name?.length <= 20" class="pointer">{{
                                    product.product_data.name }}
                                </span>
                                <span *ngIf="product?.product_data.name?.length > 20" matTooltipPosition="above"
                                    matTooltip="{{ product.product_data.name }}" class="pointer">
                                    {{ product.product_data.name | slice: 0:20}}
                                    {{ product?.product_data.name.length > 20 ? "..." : ""}}
                                </span>
                                <div>
                                    <span *ngIf="product?.product_data?.short_description?.length <= 30"
                                        class="pointer">{{product?.product_data?.short_description}}
                                    </span>
                                    <span *ngIf="product?.product_data?.short_description?.length > 30"
                                        matTooltipPosition="above"
                                        matTooltip="{{product?.product_data.short_description}}" class="pointer">
                                        {{product?.product_data.short_description | slice: 0:30}}
                                        {{product?.product_data.short_description.length > 30 ? "..." : ""}}
                                    </span>
                                </div>
                                <div class="mb-2">
                                    {{ product?.product_data?.brand_name}}
                                </div>
                                <ng-container *ngIf="product?.product_data?.attribute">
                                    <div *ngFor="let attr of product.product_data.attributes">
                                        {{attr?.attribute_name}} - {{attr?.selected_attr}}
                                    </div>
                                </ng-container>

                            </div>
                            <div class="col-2 text-right">
                                <i class="fa fa-trash pointer f-r text-info" (click)="deleteProductFromCart(product.id, 'cart')"
                                    matTooltipPosition="above" matTooltip="Delete"></i>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="mt-3">
                <button class="checkoutButton" mat-flat-button (click)="gotoCheckout()">
                    Checkout
                </button>
            </div>
        </div>


        <ul class="navbar-nav pointer" [ngClass]="{'pr-0':loggedIn}" *ngIf="!userIdParam">
            <!-- <li><a class="signin"><img src="assets/website/homepage/search-icon.svg"></a></li> -->
            <div class="w-98"
                *ngIf="showCartIcon && cartProdCount > 0 && !router.url.includes('network-market/product-cart') && !router.url.includes('/network-market/product-shipping')">
                <span (click)="cartProdCount > 0 ? goToCart() : false" class="cart-icon">
                    <i class="fa fa-shopping-cart" style="font-size:24px">
                    </i><span class="badge badge-light"> {{cartProdCount}} </span>
                </span>
            </div>
            <div class="dropdown mr-20 marketplace d-none d-md-block">
                <a class=" dropdown-toggle text-color" id="dropdownMenuButton" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false">
                    {{marketplacetext == ''? 'Marketplace':marketplacetext}}
                </a>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" routerLink="/network-market/market" routerLinkActive="bg-active"
                        (click)="getlink('market')">Merchandise</a>
                    <a class="dropdown-item" routerLink="/network-market/event" routerLinkActive="bg-active"
                        (click)="getlink('event')">Events</a>
                    <a class="dropdown-item" routerLinkActive="bg-active"
                        *ngIf="isCryptoWallet == 1 && loggedIn" (click)="checkAndNavigateToNFT()">NFT</a>
                </div>
            </div>
            <span class=" pr-10" fxhide.xs="true" fxshow="">
                <a (click)="gotoCommunities()" class="mr-2 ml-2 pointer text-color" routerLink="/communities" routerlinkactive="active" *ngIf="loggedIn">Communities</a>
            </span>
            <div class="pt-0 pr-2" fxShow fxHide.xs="true">
                <app-google-translate></app-google-translate>
            </div>
            <div class="mr-3 dropdown app-currency d-inline-block p 0"
                *ngIf="(router.url.includes('/network-market') && !router.url.includes('network-market/product-shipping')) || router.url.includes('nft/product/overview')">
                <span class="btn btn-primary btn-primary-mobile-resp dropdown-toggle gt-toggle" (click)="clearSearch()"
                    id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    <span class="d-inline-block w-150p notranslate">
                        <span *ngIf="currency?.length <= 4" class="active-color v-bottom">{{ currency
                            }}</span>
                        <span *ngIf="currency?.length > 4" class="active-color v-bottom">
                            {{ currency | slice: 0:4 }}
                            {{currency?.length > 4 ? "" : ""}}
                        </span></span>
                </span>
                <div class="dropdown-menu p-0" aria-labelledby="dropdownMenuButton2">
                    <div class="relative">
                        <input type="text" placeholder="Search.." class="search-input" [(ngModel)]="searchCurrency">
                        <i class="fa fa-search  text-white d-search" aria-hidden="true"></i>
                    </div>
                    <div class="dropdown-div">
                        <span *ngFor="let currency of currencyJSON | filter: searchCurrency:'currency';let i=index"
                            class="notranslate">
                            <a class="dropdown-item fs-13"
                                (click)="changeCurrency(currency.currency)">{{currency.currency}}</a></span>
                    </div>
                </div>
            </div>
            <!-- <span *ngIf="!loggedIn" class="pt-0  d-inline-block d-md-none d-sm-none" fxShow.xs="true"><a (click)="gotoCreator()"
                routerLinkActive="active" class="mr-2 ml-2 pointer">CREATORS</a></span>
            <li *ngIf="!loggedIn" fxShow fxHide.xs="true"> -->
            <span *ngIf="!loggedIn" class="pt-1 pr-10 m-auto" fxhide.xs="true" fxshow="">
                <a (click)="gotoCreator()" class="mr-2 ml-2 pointer" routerlinkactive="active">CREATORS</a>
            </span>
            <li *ngIf="!loggedIn" fxShow fxHide.xs="true">
                <button mat-flat-button class="flat-primary-button tertiary-bg-button"
                    (click)="redirectTo('signin')">Sign
                    In / Up</button>
            </li>
            <!-- <li *ngIf="!loggedIn" fxShow fxHide.xs="true"><a class="nav-link" (click)="redirectTo('signin')" style="background-color: transparent;"> -->
            <!-- <img
                        src="assets/website/homepage/user-icon.svg"> -->
            <!-- Sign In</a></li>
            <li *ngIf="!loggedIn" fxShow fxHide.xs="true" (click)="redirectTo('signup')"><a class="nav-link">Sign Up</a></li> -->
            <!-- <li> <a (click)="sidenav.toggle()"><img src="assets/toggle.svg"></a></li> -->

            <div class="pl-20 pointer mr-10 m-d-none text-center hoverchange"
                *ngIf="userInfo?.id && loggedIn && (router.url.includes('userhome') || router.url.includes('mylist'))"
                [ngClass]="{ 'element-active': router.url.includes('mylist') }" routerLink="/mylist">
                My List
            </div>

            <div fxShow fxHide.xs="true" id="arevea_mobile_nav" class="artist-pic m-0 text-center pointer"
                (click)="rightsidenav.toggle()"
                *ngIf="!userInfo?.is_guest && loggedIn && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>
            <button fxShow fxHide.xs="true" id="side_nav_mobile" class="profile-pic notranslate mr-10"
                (click)="rightsidenav.toggle()"
                *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo?.profile_pic == '')">
                {{displayName
                |uppercase}} </button>
            <mat-sidenav-container id="arevea_sideNav" class="Top-bar rightsidenav-parent">
                <mat-sidenav #rightsidenav mode="push" class="fs-16 text-center" position="end">
                    <mat-icon class="close_button mr-2 mt-1" (click)="rightsidenav.close()">close
                    </mat-icon>
                    <div class="row mt-30">
                        <!-- <button class="f-l  text-white mt-15 wh-40 pb-5 ml-30" mat-fab>{{displayName}}</button> -->
                        <div class="col-md-3  col-xs-3 pl-40">
                            <div id="arevea_sideNav" class="profile-pic notranslate m-0"
                                *ngIf="!userInfo?.is_guest && userInfo?.profile_pic != null && userInfo.profile_pic !=''"
                                [ngStyle]="{'background-image':' url(' + userInfo?.profile_pic + ')'}"></div>
                            <button id="arevea_sideNav" class="profile-pic notranslate f-l bg-yp-0"
                                *ngIf="!userInfo?.is_guest && loggedIn && (userInfo?.profile_pic == null || userInfo.profile_pic =='')">
                                {{displayName |uppercase}}
                            </button>
                        </div>
                        <div class="col-md-9 col-xs-9">
                            <div class="f-l mt-6">
                                <span *ngIf="profileName.length <= 16" class="pointer">{{profileName}}
                                </span>
                                <span *ngIf="profileName.length > 16" matTooltipPosition="above"
                                    matTooltip="{{profileName}}" class="pointer">
                                    {{profileName | slice: 0:16}}
                                    {{profileName.length > 16 ? "..." : ""}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="fs-14 mb-10 mt-10 logout_box" (click)="signout()" mat-button>
                            SIGN OUT
                        </button>
                    </div>
                    <div class="row mt-1">
                        <div class="col-6 text-center" *ngIf="isCryptoWallet==1">
                            <p class="cryptoName mb-1">
                                Crypto Wallet
                            </p>
                            <button mat-flat-button class="cryptoButton button1"
                                [ngClass]="{'cursor-default': walletID}">
                                <span *ngIf="walletID== undefined || walletID == '' || walletID == null"
                                    (click)="connectToWallet()">Connect</span>
                                <span *ngIf="walletID" matTooltip="{{available_balance}}"><img src="{{cryptoSymbol}}"
                                        width="16" class="mb-1"> {{ crypto_balance }}</span>
                            </button>
                        </div>
                        <div *ngIf="isCryptoWallet==1" class="col-6 text-center">
                            <p class="cryptoName mb-1">
                                Cash Wallet
                            </p>
                            <button mat-flat-button class="cryptoButton custom-red-button"
                                routerLinkActive="router-link-active" [routerLink]="cashWalletLink">
                                <span *ngIf="walletInfo?.amount != null "> {{walletInfo?.amount
                                    |currency:walletInfo?.currency}}</span>
                                <span *ngIf="walletInfo?.amount == null ">{{0.00
                                    | currency:getCurrency}}</span>
                            </button>
                        </div>

                        <div *ngIf="isCryptoWallet==0" class="col-12 text-center pb-2">
                            <p class="cryptoName mb-1">
                                Cash Wallet
                            </p>
                            <button mat-flat-button class="cryptoButton custom-red-button"
                                routerLinkActive="router-link-active" [routerLink]="cashWalletLink">
                                <span *ngIf="walletInfo?.amount != null "> {{walletInfo?.amount
                                    |currency:walletInfo?.currency}}</span>
                                <span *ngIf="walletInfo?.amount == null ">{{0.00
                                    | currency:getCurrency}}</span>
                            </button>
                        </div>
                    </div>
                    <div class="line mt-1"></div>
                    <div class="text-left lh-42 mt-5">

                        <!-- <div>
                      <a class="c-lg ml-25" href="">Category</a>
                    </div> -->
                        <div class="pl-20 fw-600" *ngIf="channelUrl=='channel'" fxShow.sm="true" fxHide="true">Channel
                            Menu</div>
                        <div *ngFor="let list of userList" fxShow.sm="true" fxHide="true">
                            <div class="pointer pl-20" *ngIf="channelUrl=='channel'" [ngClass]="{
                                    'active-menu': list.activeMenu,
                                    'mb-5': list.activeMenu
                                  }" (click)="goToUser(list.link,list)">
                                <div class="ml-5 " *ngIf="!list.hide">{{ list.name }}</div>
                            </div>
                        </div>
                        <div class="pl-20 fw-600" *ngIf="channelUrl=='channel'" fxShow.sm="true" fxHide="true">User
                            Dashboard
                        </div>
                        <div *ngFor="let list of menuList">
                            <div class="pointer pl-20"
                                *ngIf="list.sub_menu && list.sub_menu.length == 0 && list.dualapp" [ngClass]="{
                                    'active-menu': list.activeMenu,'bg-primary':list.activeMenu,
                                    'mb-5': list.activeMenu
                                  }" (click)="goToMenu(list.link,list)">
                                <div class="ml-5 " *ngIf="!list.hide ">{{ list.name}}</div>
                            </div>

                            <span class="menu-name" *ngIf="list.sub_menu && list.sub_menu.length > 0">
                                <mat-expansion-panel [expanded]="list.activeMenuList" (opened)="list.activeMenuList"
                                    (closed)="!list.activeMenuList" [ngClass]="{
                      'active-menu': list.activeMenuList,
                      'mb-5': list.activeMenuList
                    }" (click)="goToMenu(list.link, list)">
                                    <mat-expansion-panel-header [ngClass]="{'bg-primary':list.activeMenuList}">
                                        <mat-panel-title>
                                            <div class="menu-padding pointer pr-3">
                                                <span class="menu-name ml-txt">{{ list.name }}</span>
                                                <i class="fa fa-angle-right ml-35" *ngIf="!list.activeMenuList"></i>
                                                <i class="fa fa-angle-down ml-35" *ngIf="list.activeMenuList"></i>
                                            </div>
                                        </mat-panel-title>
                                    </mat-expansion-panel-header>
                                    <div fxLayout="column" class="pt-10">
                                        <div class=" menu-name ml-45 pointer" *ngFor="let menu of list.sub_menu"
                                            [ngClass]="{
                          'active-type': menu.subMenuActive}">
                                            <div (click)="navigateSubmenu(menu.link)" *ngIf="menu.dualapp">
                                                {{menu.menu_name}} {{deviceInfo}}</div>

                                        </div>
                                    </div>
                                </mat-expansion-panel>
                            </span>

                        </div>
                    </div>

                </mat-sidenav>

            </mat-sidenav-container>
        </ul>
    </div>


    <ng-container *ngIf="isNetworkNotification">
        <!-- <div class="dropdown">
            <button class="btn btn-secondary" type="button" id="dropdownMenu2" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">

            </button><span class="left-border"> </span> -->
        <div class="app-notification">
            <div class="position-ab-notification">
                <div class="row no-gutters title-cls">
                    <div class="col-11">
                        <p class="fs-15 mb-0">{{message}}</p>
                    </div>
                    <div class="col-1 text-right pointer" (click)=closeBox()>
                        <i class="fa fa-times-circle" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="row no-gutters p-3">
                    <div class="col-12 text-center">
                        <button class="join-nt-btn pt-5" (click)="joinUrl()">JOIN</button>
                    </div>
                </div>
                <!-- <div class="bg-secondary-embed ff text-white">
                    <span class="ellipsis-text pointer pt-5">{{inviteKey}}</span> <span> <button class="copy-btn pt-5"
                            id="btnCopyClip" (click)="copyToClipboard()">COPY</button>
                    </span>
                </div> -->
            </div>
            <!-- </div> -->
        </div>
    </ng-container>
</nav>